import e from "react";
import { translate as t } from "@aws-amplify/ui";
import { useAuthenticator as n } from "@aws-amplify/ui-react-core";
import { Tabs as i, TabItem as r } from "../../../primitives/Tabs/Tabs.js";
import { View as o } from "../../../primitives/View/View.js";
import { SignIn as a } from "../SignIn/SignIn.js";
import { SignUp as m } from "../SignUp/SignUp.js";
import { RouteContainer as c } from "../RouteContainer/RouteContainer.js";
const l = _ref => {
  let {
    className: l,
    hideSignUp: s,
    variation: p
  } = _ref;
  const {
    route: g,
    toSignIn: u,
    toSignUp: f
  } = n(e => [e.route, e.toSignIn, e.toSignUp]);
  return e.createElement(c, {
    className: l,
    variation: p
  }, s ? e.createElement(o, {
    "data-amplify-router-content": ""
  }, "signIn" === g && e.createElement(a, null)) : e.createElement(i, {
    indicatorPosition: "top",
    currentIndex: "signIn" === g ? 0 : 1,
    spacing: "equal",
    justifyContent: "center",
    onChange: () => "signIn" === g ? f() : u()
  }, e.createElement(r, {
    title: t("Sign In")
  }, e.createElement(o, {
    "data-amplify-router-content": ""
  }, "signIn" === g && e.createElement(a, null))), e.createElement(r, {
    title: t("Create Account")
  }, e.createElement(o, {
    "data-amplify-router-content": ""
  }, "signUp" === g && e.createElement(m, null)))));
};
export { l as SignInSignUpTabs };